import React, { useState } from "react";
import { Doughnut } from "react-chartjs-2";
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    Title,
} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend, Title);

function EmailResults({ result, isInProgress, progress, progressResults }) {

    const [activeIndex, setActiveIndex] = useState(null);

    const total = result?.total || 0;
    const deliverableCount = result?.stats?.deliverable || 0;
    const undeliverableCount = result?.stats?.undeliverable || 0;
    const stats = result?.stats || {};

    console.log(progressResults)

    const chartData = {
        labels: ["Deliverable", "Undeliverable"],
        datasets: [
            {
                data: [deliverableCount, undeliverableCount],
                backgroundColor: ["#34D399", "#F87171"],
                hoverOffset: 10,
                borderWidth: 1,
            },
        ],
    };

    const totalValid = deliverableCount + undeliverableCount;

    const centerTextPlugin = {
        id: "centerText",
        beforeDraw: (chart) => {
            const { width, height, ctx } = chart;
            const text1 = chart.config.options.centerText?.text1 || "";
            const text2 = chart.config.options.centerText?.text2 || "";

            ctx.save();
            ctx.font = "bold 36px sans-serif";
            ctx.fillStyle = "#2C2C2C";
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText(text1, width / 2, height / 2 - 10);

            ctx.font = "18px sans-serif";
            ctx.fillStyle = "#666";
            ctx.fillText(text2, width / 2, height / 2 + 14);

            ctx.restore();
        }
    };

    ChartJS.register(centerTextPlugin);

    return (
        <div className="results-container">
            {isInProgress === "completed" ? (
                <div className="results-summary">
                    <div><strong>FILE NAME</strong><br />{result?.name}</div>
                    <div><strong>EMAILS</strong><br />{total}</div>
                    <div><strong>UPLOADED</strong><br />{result?.date}</div>
                </div>
            ) : (
                <div className="results-summary">
                    <div><strong>FILE NAME</strong><br />{progressResults?.name}</div>
                    <div><strong>EMAILS</strong><br />{progressResults?.total}</div>
                    <div><strong>UPLOADED</strong><br />{progressResults?.date}</div>
                </div>
            )}

            <div className="results-chart">
                <div className="chart-wrapper">
                    <Doughnut
                        data={isInProgress ? {
                                    labels: ["Progress", "Remaining"],
                                    datasets: [
                                        {
                                            data: [progress, 100 - progress],
                                            backgroundColor: ["#D98E4B", "#e5e7eb"], // purple and light gray
                                            borderWidth: 0,
                                        },
                                    ],
                                }
                                : chartData
                        }
                        options={{
                            cutout: "70%",
                            responsive: true,
                            animation: {
                                animateRotate: true,
                                animateScale: true,
                            },
                            plugins: {
                                legend: { display: false },
                                tooltip: {
                                    enabled: !isInProgress, // 🛑 Disable tooltip when scrubbing
                                    callbacks: {
                                        label: function (context) {
                                            const label = context.label || "";
                                            const value = context.parsed;
                                            const percent = (
                                                (value / chartData.datasets[0].data.reduce((a, b) => a + b, 0)) *
                                                100
                                            ).toFixed(1);
                                            return `${label}: ${value} (${percent}%)`;
                                        },
                                    },
                                },
                            },
                            hover: {
                                mode: isInProgress ? null : "nearest", // 🛑 Disable segment hover
                            },
                            onHover: isInProgress
                                ? undefined
                                : (event, chartElement) => {
                                    if (chartElement.length > 0) {
                                        setActiveIndex(chartElement[0].index);
                                    } else {
                                        setActiveIndex(null);
                                    }
                                },
                            centerText: isInProgress
                                ? {
                                    text1: `${progress}%`,
                                    text2: "Scrubbing",
                                }
                                : {
                                    text1:
                                        activeIndex !== null
                                            ? chartData.datasets[0].data[activeIndex]
                                            : `${deliverableCount}`,
                                    text2:
                                        activeIndex !== null
                                            ? chartData.labels[activeIndex]
                                            : "Deliverable",
                                },
                        }}
                    />
                    {/*<div className="chart-center">*/}
                    {/*    {isInProgress ? (*/}
                    {/*        <>*/}
                    {/*            <div className="chart-percent">{progress}%</div>*/}
                    {/*            <div className="chart-label">Scrubbing</div>*/}
                    {/*        </>*/}
                    {/*    ) : activeIndex !== null ? (*/}
                    {/*        <>*/}
                    {/*            <div className="chart-percent">*/}
                    {/*                {chartData.datasets[0].data[activeIndex]}*/}
                    {/*            </div>*/}
                    {/*            <div className="chart-label">*/}
                    {/*                {chartData.labels[activeIndex]}*/}
                    {/*            </div>*/}
                    {/*        </>*/}
                    {/*    ) : (*/}
                    {/*        <>*/}
                    {/*            <div className="chart-percent">{deliverableCount}</div>*/}
                    {/*            <div className="chart-label">Deliverable</div>*/}
                    {/*        </>*/}
                    {/*    )}*/}
                    {/*</div>*/}
                </div>
            </div>

            {!isInProgress && (
                <div className="results-legend">
                    {Object.entries(stats).map(([key, value], index) => {
                        const colors = ["#34D399", "#F87171", "#FBBF24", "#60A5FA", "#A78BFA"];
                        const percent = ((value / totalValid) * 100).toFixed(1);
                        return (
                            <div key={key} className="legend-item">
                                <span
                                    className="color-dot"
                                    style={{ backgroundColor: colors[index] }}
                                />
                                {percent}% {key.charAt(0).toUpperCase() + key.slice(1)} — {value}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}

export default EmailResults;